import React, { FC } from 'react'

import { observer } from 'mobx-react'

import {
  Card,
  CardsContainer,
  CardsWrapper,
  DesktopBodyWrapper,
  HeadingBannerDesktop,
  Page,
  SignUpButton,
} from './LandingPage.styles'

import imgBanner from '../..//assets/banner-image.png'
import card1 from '../../assets/cards/card1.png'
import card2 from '../..//assets/cards/card2.png'
import card3 from '../..//assets/cards/card3.png'

import { Header } from '../../components/Header/Header'
import { LandingPageMobile } from './LandingPageMobile'

export const LandingPage: FC = () => (
  <>
    <LandingPageMobile />
    <Page>
      <Header />
      <HeadingBannerDesktop>
        <img src={imgBanner} alt="placeholder" />

        <h1>
          Banking, Simplified.
          <br /> Onboard in <span>3 minutes</span>.
        </h1>

        <div>
          Zero Fees. Total Freedom. <br />
          Your Money, Your Rules - No Fees, No Hassle
        </div>

        <SignUpButton href="/steps">
          Open an account
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="31"
            viewBox="0 0 30 31"
            fill="none"
          >
            <path
              d="M16.1995 8.46503C15.8822 8.14773 15.3678 8.14773 15.0505 8.46503C14.7332 8.78233 14.7332 9.29677 15.0505 9.61407L19.9134 14.477L8.125 14.477C7.67627 14.477 7.3125 14.8408 7.3125 15.2895C7.3125 15.7383 7.67627 16.102 8.125 16.102L19.9135 16.102L15.0505 20.965C14.7332 21.2823 14.7332 21.7968 15.0505 22.1141C15.3678 22.4314 15.8822 22.4314 16.1995 22.1141L22.4495 15.8641C22.7668 15.5468 22.7668 15.0323 22.4495 14.715L16.1995 8.46503Z"
              fill="white"
            />
          </svg>
        </SignUpButton>
      </HeadingBannerDesktop>

      <DesktopBodyWrapper>
        <CardsContainer>
          <h2>
            Financial services built to <span>support</span> your revolution
          </h2>
          <CardsWrapper>
            <Card>
              <h3>
                Personal account{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                >
                  <path
                    d="M16.1995 8.17548C15.8822 7.85817 15.3677 7.85817 15.0504 8.17548C14.7331 8.49278 14.7331 9.00722 15.0504 9.32452L19.9134 14.1875L8.12497 14.1875C7.67624 14.1875 7.31247 14.5513 7.31247 15C7.31247 15.4487 7.67624 15.8125 8.12497 15.8125L19.9134 15.8125L15.0504 20.6755C14.7331 20.9928 14.7331 21.5072 15.0504 21.8245C15.3677 22.1418 15.8822 22.1418 16.1995 21.8245L22.4495 15.5745C22.7668 15.2572 22.7668 14.7428 22.4495 14.4255L16.1995 8.17548Z"
                    fill="#A963EC"
                  />
                </svg>
              </h3>
              <img src={card1} alt="card1" />
            </Card>
            <Card>
              <h3>
                Corporate account{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                >
                  <path
                    d="M16.1995 8.17548C15.8822 7.85817 15.3677 7.85817 15.0504 8.17548C14.7331 8.49278 14.7331 9.00722 15.0504 9.32452L19.9134 14.1875L8.12497 14.1875C7.67624 14.1875 7.31247 14.5513 7.31247 15C7.31247 15.4487 7.67624 15.8125 8.12497 15.8125L19.9134 15.8125L15.0504 20.6755C14.7331 20.9928 14.7331 21.5072 15.0504 21.8245C15.3677 22.1418 15.8822 22.1418 16.1995 21.8245L22.4495 15.5745C22.7668 15.2572 22.7668 14.7428 22.4495 14.4255L16.1995 8.17548Z"
                    fill="#A963EC"
                  />
                </svg>
              </h3>
              <img src={card2} alt="card2" />
            </Card>
            <Card>
              <h3>
                Business account{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                >
                  <path
                    d="M16.1995 8.17548C15.8822 7.85817 15.3677 7.85817 15.0504 8.17548C14.7331 8.49278 14.7331 9.00722 15.0504 9.32452L19.9134 14.1875L8.12497 14.1875C7.67624 14.1875 7.31247 14.5513 7.31247 15C7.31247 15.4487 7.67624 15.8125 8.12497 15.8125L19.9134 15.8125L15.0504 20.6755C14.7331 20.9928 14.7331 21.5072 15.0504 21.8245C15.3677 22.1418 15.8822 22.1418 16.1995 21.8245L22.4495 15.5745C22.7668 15.2572 22.7668 14.7428 22.4495 14.4255L16.1995 8.17548Z"
                    fill="#A963EC"
                  />
                </svg>
              </h3>
              <img src={card3} alt="card3" />
            </Card>
          </CardsWrapper>
        </CardsContainer>
      </DesktopBodyWrapper>
    </Page>
  </>
)
